import React from "react";
import gql from "graphql-tag";
import {Query} from "react-apollo";
import PersonIcon from "react-icons/lib/io/android-person";
import CountDown, {Number} from "./CountDown";
import s from "./LiveEventRealTimeStats.pcss";

export const query = gql`
    query LiveEventRealTimeStats($id: String) {
        liveEvent(slug: "", universitySlug: "", id: $id) {
            id
            end
            detailedReport {
                prospectsSendMessage
            }
        }
    }
`;

export const Icon = ({children}) => <span className={s.icon}>{children}</span>;

/**
 * Displays and formats stats about the live event, re-checking every 30 seconds.
 *
 * @param {String} {liveEventId}
 * @returns
 */
const LiveEventRealTimeStats = ({liveEventId}) => {
    return (
        <Query query={query} variables={{id: liveEventId}} pollInterval={300000}>
            {({data, loading, error}) => {
                if (!liveEventId || loading || error) return null;
                const {
                    end,
                    detailedReport: {prospectsSendMessage},
                } = data.liveEvent;

                return (
                    <div data-test-id="live-event-stats">
                        <CountDown end={end} />
                        {prospectsSendMessage > 10 && (
                            <div data-test-id="active-participants" className={s.container}>
                                <Icon>
                                    <PersonIcon />
                                </Icon>
                                <Number>{prospectsSendMessage}</Number> students chatting now
                            </div>
                        )}
                    </div>
                );
            }}
        </Query>
    );
};

export default LiveEventRealTimeStats;
